import { AxiosError } from "axios";

import { getBaseUrl } from "@config";

import { errorCodes, logoutErrorsStatuses } from "@api/interceptors/constants";
import { InterceptorErrorHandler } from "@api/interceptors/types";
import { handleLogout } from "@api/interceptors/utils";

const logoutErrors = [
  errorCodes["403"].forbidden.lockedPortal,
  errorCodes["403"].forbidden.userNotAllowedToAccessPlus,
  errorCodes["403"].forbidden.userNotMemberInBranch,
  errorCodes["403"].forbidden.branchInactive,
  errorCodes["403"].forbidden.userNotFound,
  errorCodes["403"].forbidden.userNotActive,
];

export const logOutInterceptor: InterceptorErrorHandler = (error: AxiosError) => {
  const { response } = error;
  const errorId = response?.data?._errors?.[0]?.id;

  if (
    response?.status &&
    logoutErrorsStatuses.includes(response.status) &&
    logoutErrors.includes(errorId)
  ) {
    handleLogout();
    window.location.href = getBaseUrl();

    return Promise.reject(error);
  }

  return error;
};
